import React from "react";
import "./footer.scss";
import GoogleLogoBlack from "../../assets/images/google-black.svg";
import AppleLogo from "../../assets/images/appstore2.svg";

import { useNavigate } from "react-router-dom";
import { SiInstagram } from "react-icons/si";
import { FaXTwitter, FaFacebookF } from "react-icons/fa6";
const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  return (
    <>
      <footer>
        {/* <div className='footer-top'>
          <div className='footer-logo'> <img src={Logo} alt='Helpr' /></div>

          <h2 className='text-center'>Lorem ipsum dolor sit amet, consectetur</h2>
          <p className='text-center'>sed do eiusmod tempor incididunt ut labore Ut enim ad minim veniam, quis nostrud exercitation</p>
          <div className='app-store-logos'>
            <div className='app-logo'><img src={GoogleLogo} alt='Helpr' /></div>
            <div className='app-logo'><img src={GoogleLogoBlack} alt='Helpr' /></div>
          </div>
          <div className='social-link  text-center' style={{ display: "flex", justifyContent:"center", alignItems:"center",}} >
          <h2><div style={{ display: "flex", gap: "15px"}}><SiInstagram  />  <FaFacebookF/>  <FaXTwitter /> </div></h2>
          </div>
        </div>
        <div className='footer-bottom-wrap'>
          <div className='container-wrap'>
            <div className='footer-nav-wrap'>
              <div className='order-1 order-md-0'>&copy; {currentYear} , All Rights Reserved</div>
              <ul className='order-0 order-md-1'>
                <li onClick={()=>navigate("/aboutus")}>About Us</li>
                <li onClick={()=>navigate("/faq")}>FAQ</li>
                <li onClick={()=>navigate("/termofservices")}>Terms of Services</li>
                <li onClick={()=>navigate("/privacypolicy")}>Privacy Policy</li>
                <li onClick={()=>navigate("/cookiepolicy")}>Cookie Policy</li>
              </ul>
            </div>
          </div>
        </div> */}

        <div className="footer-top">
          <div className="social-link  text-center">
            <span className="social-link-heading">
              Follow us! We're friendly:{" "}
            </span>
            <h2>
              <div
                style={{ display: "flex", gap: "15px" }}
                className="social-link-site"
              >
                <SiInstagram /> | <FaFacebookF /> | <FaXTwitter />{" "}
              </div>
            </h2>
          </div>
          <div className="header-content">
            <div className="header-discover-section">
              <div className="header-discover-section-heading">
                <span>Discover</span>
              </div>
              <div className="header-discover-section-content"></div>
            </div>
            <div className="header-info-section">
              <div className="header-info-section-heading">
                <span>Company</span>
              </div>
              <div className="header-info-section-content">
                <ul className="">
                  <li onClick={() => navigate("/contactus")}>Contact Us</li>
                  <li onClick={() => navigate("/aboutus")}>About Us</li>
                  <li onClick={() => navigate("/faq")}>FAQ</li>
                  <li onClick={() => navigate("/termofservices")}>
                    Terms of Services
                  </li>
                  <li onClick={() => navigate("/privacypolicy")}>
                    Privacy Policy
                  </li>
                  <li onClick={() => navigate("/cookiepolicy")}>
                    Cookie Policy
                  </li>
                </ul>
              </div>
            </div>
            <div className="header-app-section">
              <div className="header-app-section-heading">
                <div className="header-app-section-heading-main">
                  <span>Download our app</span>
                </div>
                <div className="header-app-section-heading-sub">
                  <span>
                    Tackle your jobs wherever you are with our mobile app.
                  </span>
                </div>
              </div>
              <div className="app-store-logos">
                <div className="app-logo">
                 <a href="https://apps.apple.com/us/app/helpr-bm/id6478659797"><img src={AppleLogo} alt="Helpr" /></a>
                </div>
                <div className="app-logo">
                <a href="https://play.google.com/store/apps/details?id=com.helpr.helpr1"><img src={GoogleLogoBlack} alt="Helpr" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom-wrap">
          <div className="container-wrap">
            <div className="footer-nav-wrap">
              <div className="order-1 order-md-0">
                &copy; {currentYear} , All Rights Reserved
              </div>
              {/* <ul className="order-0 order-md-1">
                <li onClick={() => navigate("/aboutus")}>About Us</li>
                <li onClick={() => navigate("/faq")}>FAQ</li>
                <li onClick={() => navigate("/termofservices")}>
                  Terms of Services
                </li>
                <li onClick={() => navigate("/privacypolicy")}>
                  Privacy Policy
                </li>
                <li onClick={() => navigate("/cookiepolicy")}>Cookie Policy</li>
              </ul> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
